import { createSlice } from '@reduxjs/toolkit';

/**
 * DetailDialog 상태 관리
 * - open: DetailDialog 열림 여부
 * - detailData: 상세 내역 데이터 배열
 * - title: 다이얼로그 제목
 * - closeButtonName: 닫기 버튼 텍스트
 * - maxWidth: 다이얼로그 최대 너비
 *
 * 사용 예시:
 * dispatch(openDetailDialog({
 *   detailData: resultArray,
 *   title: '처리 상세 내역'
 * }));
 * dispatch(closeDetailDialog());
 */

const initialState = {
  open: false,
  detailData: null,
  title: '처리 상세 내역',
  closeButtonName: '닫기',
  maxWidth: 'md',
};

const DetailDialogSlice = createSlice({
  name: 'DetailDialog',
  initialState,
  reducers: {
    openDetailDialog: (state, action) => {
      const {
        detailData = null,
        title = '처리 상세 내역',
        closeButtonName = '닫기',
        maxWidth = 'md',
      } = action.payload || {};
      state.open = true;
      state.detailData = detailData;
      state.title = title;
      state.closeButtonName = closeButtonName;
      state.maxWidth = maxWidth;
    },
    closeDetailDialog: (state) => {
      state.open = false;
      state.detailData = null;
    },
  },
});

export const { openDetailDialog, closeDetailDialog } =
  DetailDialogSlice.actions;
export default DetailDialogSlice.reducer;
